// Tiny build-version badge fixed to the bottom-right of every page.
// The value is replaced at build time by Vite via `define` (see vite.config.ts).
declare const __BUILD_VERSION__: string;

const BUILD_VERSION =
  typeof __BUILD_VERSION__ !== "undefined" ? __BUILD_VERSION__ : "dev";

export function VersionBadge() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed bottom-1 right-1.5 z-[1000] select-none font-mono text-[9px] leading-none text-muted-foreground sm:text-[10px]"
      title={`Build ${BUILD_VERSION} (UTC)`}
    >
      v{BUILD_VERSION}
    </div>
  );
}
